import { useEffect, useState } from "react"
import { formatRegions } from "../config/regionConfig"
import axios from "axios"
import Cookies from "js-cookie"
// const isEmpty = require("lodash/isEmpty")
import isEmpty from "lodash.isempty"

const useLocation = (
  regions,
  internationalLabel,
  internationalMachineName,
  setRegions,
  contentfulRegions
) => {
  const formattedRegions = formatRegions(regions)
  const [country, setCountry] = useState(null)
  const [regionFromURL, setRegionFromURL] = useState(null)
  const cookiesLanguage = Cookies.get("languageSettings")

  const fetchCountry = regionFromURL => {
    axios
      .get(`https://pro.ip-api.com/json/?key=${process.env.GATSBY_IP_API_KEY}`)
      .then(
        response => {
          if (response && response?.data) {
            if (!regionFromURL) {
              const getMachineName = formattedRegions.find(reg => {
                return (
                  reg.isoCode?.toLowerCase() ===
                  response?.data?.countryCode?.toLowerCase()
                )
              })
              if (getMachineName) {
                setCountry({
                  countryName: response?.data?.country,
                  isoCode: response?.data?.countryCode,
                  machineName: getMachineName?.machineName,
                })
              } else {
                setCountry({
                  countryName: internationalLabel
                    ? internationalLabel
                    : "International",
                  name: internationalLabel
                    ? internationalLabel
                    : "International",
                  region: internationalLabel
                    ? internationalLabel
                    : "International",
                  isoCode: internationalLabel
                    ? internationalLabel
                    : "International",
                  machineName: internationalMachineName
                    ? internationalMachineName
                    : "international",
                })
              }
            }
          }
        },
        error => {
          console.log(error)
          // add this in case the user is using a browser like Brave that blocks IP lookups. Without this, on Brave browser the navbar does not render bc it is dependent on having a region.
          setCountry({
            countryName: internationalLabel
              ? internationalLabel
              : "International",
            name: internationalLabel ? internationalLabel : "International",
            region: internationalLabel ? internationalLabel : "International",
            isoCode: internationalLabel ? internationalLabel : "International",
            machineName: internationalMachineName
              ? internationalMachineName
              : "international",
          })
        }
      )
  }

  useEffect(() => {
    if (typeof window !== undefined) {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      })

      setRegionFromURL(params?.iso)

      if (cookiesLanguage && !regionFromURL) {
        setCountry({
          region: JSON.parse(cookiesLanguage)?.region,
          machineName: JSON.parse(cookiesLanguage)?.machineName,
        })
        return
      }

      if (regionFromURL && formattedRegions?.length) {
        const region = formattedRegions.find(region => {
          return region?.isoCode.toLowerCase() === regionFromURL.toLowerCase()
        })

        if (region) {
          setCountry(region)
        } else {
          // if query iso code is incorrect or does not exist, we will default to global region
          setCountry({
            countryName: internationalLabel
              ? internationalLabel
              : "International",
            name: internationalLabel ? internationalLabel : "International",
            region: internationalLabel ? internationalLabel : "International",
            isoCode: internationalLabel ? internationalLabel : "International",
            machineName: internationalMachineName
              ? internationalMachineName
              : "international",
          })
        }
      } else if (!country && !regionFromURL) {
        fetchCountry(regionFromURL)
      }
    }
  }, [regionFromURL, cookiesLanguage, regions])

  useEffect(() => {
    if (regions && regions?.length) {
      if (
        (country?.region && country?.region === internationalLabel) ||
        contentfulRegions?.length === 1
      ) {
        const checkForInternational = regions?.find(region => {
          return region?.machineName === internationalMachineName
        })

        // if user is in international region and there are no other regions, we add international to the list
        if (isEmpty(checkForInternational)) {
          setRegions([
            ...[
              {
                region: internationalLabel
                  ? internationalLabel
                  : "International",
                machineName: internationalMachineName
                  ? internationalMachineName
                  : "international",
                name: internationalLabel ? internationalLabel : "International",
              },
            ],
            ...regions,
          ])
        }
        // if user is in region that exists AND there are more than one region, we do not add international to the list
      } else if (
        country?.region !== internationalLabel &&
        contentfulRegions?.length > 1
      ) {
        setRegions(contentfulRegions)
      }
    }
  }, [country, regions])

  return { country }
}

export default useLocation
